import React from 'react';
import {Container, Flex, Title, RadioContainer} from './styles';
import RadioBox from './RadioBox';
import subscriptionPlan from '../../content/subscriptionPlan.js';
import {dailyPackage} from '../../content/subscriptionPlan.js';

const SubscriptionPackages = ({radioState, currency, isActiveSubscription}) => {
  const [selectedPlan, setSelectedPlan] = radioState;

  const plan = selectedPlan === 'DAILY' ? dailyPackage : subscriptionPlan;
  return (
    <Container>
      {!isActiveSubscription ? (
        <Flex>
          <img src="/subscription/medal.svg" />

          <Title>
            تجربة مجانية لمدة <span>7 أيام</span> لجميع الاشتراكات
          </Title>
        </Flex>
      ) : null}

      <RadioContainer>
        {plan?.map((plan, index) => (
          <RadioBox
            key={plan.planType}
            radioValue={selectedPlan}
            setRadioValue={setSelectedPlan}
            subscriptionPlan={plan}
            order={index}
            currency={currency}
          />
        ))}
      </RadioContainer>
    </Container>
  );
};

export default SubscriptionPackages;
